import routes from "../../constants/routes";
import axios from "axios";
import { Account } from "../../pages/Settings/Shared/Entities/Account";
import {ApiResponse} from "tendril-v1/src/types/ApiResponse";
import {SalesforceAccount} from "tendril-v2/src/Data/DataSource/sync/salesforce/dto/get-salesforcer-accounts.dto";

const getSalesforceAccountsAsync = async (
  userId: string,
  orgId: string,
): Promise<ApiResponse<SalesforceAccount[]>> => {
  try {
    const salesforceAccounts = await axios.get<SalesforceAccount[]>(
      `${routes.get.salesforce.getLinkedAccounts}/${orgId}/${userId}`
    );

    return { data: salesforceAccounts.data, success: true, status: salesforceAccounts.status };
  } catch (error) {
    return { error: { message: "Error while getting salesforce accounts." } };
  }
};

export default getSalesforceAccountsAsync;
